let loaderPromise = null

export function loadKakaoMaps () {
  const kakao = window.kakao || window.daum
  if (kakao && kakao.maps) {
    return new Promise(resolve => {
      kakao.maps.load(() => resolve(kakao.maps))
    })
  }
  if (loaderPromise) return loaderPromise

  loaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=' + process.env.KAKAO_MAP_KEY + '&libraries='
    script.async = true
    script.onload = function () {
      const kakao = window.kakao || window.daum
      if (!kakao || !kakao.maps) {
        loaderPromise = null
        reject(new Error('Kakao Maps SDK did not initialize'))
        return
      }
      kakao.maps.load(() => resolve(kakao.maps))
    }
    script.onerror = function (error) {
      loaderPromise = null
      reject(error)
    }
    document.head.appendChild(script)
  })

  return loaderPromise
}



// WEBPACK FOOTER //
// ./src/util/kakaoMapsLoader.js